package com.devi3east.bashbuddy.features.events.requests

import com.devi3east.bashbuddy.common.domain.models.Address
import com.devi3east.bashbuddy.features.events.common.data.models.EventType
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class UpdateDraftEventRequest(
    val title: String,
    val description: String,
    val startInstant: Instant? = null,
    val endInstant: Instant? = null,
    val isMultiDay: Boolean = false,
    val eventType: EventType = EventType.REGULAR,
    val address: Address? = null,
    val imageUrl: String? = null,
    val attendanceAge: Int? = null
)